import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AverageRatingCount from '~/components/Layout/consumerAdvice/AverageRatingCount.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import WishlistButton from '~/components/Product/WishlistButton.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useUser } from '~/composables/_next/useUser';
import { useCart } from '~/composables/useCart';
import { useProductPropertiesAttributes } from '~/composables/useProductPropertiesAttributes';
import useRightPath from '~/composables/useRightPath';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useWait } from '~/composables/_next/useWait';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { gtmPushEvent, gtmDiscountValue, gtmValue, gtmPriceFormat } from '~/helpers/gtm';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import useShippingCountry from '~/composables/useShippingCountry';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardAlgoliaOrganism',
  props: {
    product: null,
    imageWidth: {
      default: 262
    },
    imageHeight: {
      default: 194
    },
    imageLoading: {
      default: 'lazy'
    },
    productIndex: {
      default: 0
    },
    isPlp: {
      type: Boolean
    },
    direction: {
      default: 'column'
    }
  },
  setup: function setup(__props) {
    var _user$value;
    var props = __props;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency,
      locale = _useLocalization.locale;
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var _useCart = useCart(),
      addItemById = _useCart.addItemById,
      cart = _useCart.cart;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useProductProperties = useProductPropertiesAttributes(),
      getFinalAttributeFromStrings = _useProductProperties.getFinalAttributeFromStrings;
    var router = useRouter();
    var route = useRoute();
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var _useUiState = useUiState(),
      openBackInStockModal = _useUiState.openBackInStockModal,
      openAddToCartModal = _useUiState.openAddToCartModal;
    var customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    var productIdFromTags = computed(function () {
      var _props$product$_tags, _props$product, _tag$split$;
      var tags = (_props$product$_tags = props === null || props === void 0 ? void 0 : (_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product._tags) !== null && _props$product$_tags !== void 0 ? _props$product$_tags : [];
      var tag = Array.isArray(tags) ? tags.find(function (t) {
        return typeof t === 'string' && t.startsWith('product:');
      }) : '';
      return (_tag$split$ = tag === null || tag === void 0 ? void 0 : tag.split(':')[1]) !== null && _tag$split$ !== void 0 ? _tag$split$ : '';
    });
    var reviewsSku = computed(function () {
      var _props$product2, _props$product$key, _props$product3;
      var variantIDs = Array.isArray((_props$product2 = props.product) === null || _props$product2 === void 0 ? void 0 : _props$product2.variantIDs) ? props.product.variantIDs : [];
      var productKey = (_props$product$key = (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : _props$product3.key) !== null && _props$product$key !== void 0 ? _props$product$key : '';
      return [].concat(_toConsumableArray(variantIDs), [productKey]).filter(Boolean).join(',');
    });
    var isInStock = computed(function () {
      return masterVariant.value.isInStock || hasVariantInStock(props.product.variants);
    });
    var variantCount = computed(function () {
      var _props$product$varian;
      return ((_props$product$varian = props.product.variants) === null || _props$product$varian === void 0 ? void 0 : _props$product$varian.length) || 1;
    });
    var isVariant = computed(function () {
      return variantCount.value > 1;
    });
    var price = computed(function () {
      return getPricesByCountry(masterVariant.value.prices, currentCountry.value);
    });
    var isNew = computed(function () {
      var _props$product4, _props$product4$attri;
      return (_props$product4 = props.product) === null || _props$product4 === void 0 ? void 0 : (_props$product4$attri = _props$product4.attributes) === null || _props$product4$attri === void 0 ? void 0 : _props$product4$attri['is-new-product'];
    });
    var link = computed(function () {
      var defaultLink = app.localePath(getProductPath(props.product));
      return defaultLink;
    });
    var title = computed(function () {
      var _props$product5;
      return (_props$product5 = props.product) === null || _props$product5 === void 0 ? void 0 : _props$product5.name;
    });
    var gtmEcommerceItems = computed(function () {
      var _price$value, _price$value2, _price$value3, _price$value4, _price$value5, _price$value6, _price$value7, _price$value8, _price$value9, _price$value0;
      return {
        value: gtmValue((_price$value = price.value) === null || _price$value === void 0 ? void 0 : _price$value.regular, (_price$value2 = price.value) === null || _price$value2 === void 0 ? void 0 : _price$value2.special),
        value_in_cents: gtmValue((_price$value3 = price.value) === null || _price$value3 === void 0 ? void 0 : _price$value3.regular, (_price$value4 = price.value) === null || _price$value4 === void 0 ? void 0 : _price$value4.special, true),
        items: [{
          item_id: "SKU_".concat(masterVariant.value.sku),
          item_sku: masterVariant.value.sku,
          item_name: title.value,
          discount: gtmDiscountValue((_price$value5 = price.value) === null || _price$value5 === void 0 ? void 0 : _price$value5.regular, (_price$value6 = price.value) === null || _price$value6 === void 0 ? void 0 : _price$value6.special),
          discount_in_cents: gtmDiscountValue((_price$value7 = price.value) === null || _price$value7 === void 0 ? void 0 : _price$value7.regular, (_price$value8 = price.value) === null || _price$value8 === void 0 ? void 0 : _price$value8.special, true),
          new_product: isNew.value,
          index: Number(props.productIndex) + 1,
          item_location: 'product_card',
          price: gtmPriceFormat((_price$value9 = price.value) === null || _price$value9 === void 0 ? void 0 : _price$value9.regular),
          price_in_cents: gtmPriceFormat((_price$value0 = price.value) === null || _price$value0 === void 0 ? void 0 : _price$value0.regular, true),
          currency: currency
        }]
      };
    });
    var finalAttributesString = computed(function () {
      var _props$product6, _props$product6$attri, _props$product7, _props$product7$attri;
      return getFinalAttributeFromStrings((_props$product6 = props.product) === null || _props$product6 === void 0 ? void 0 : (_props$product6$attri = _props$product6.attributes) === null || _props$product6$attri === void 0 ? void 0 : _props$product6$attri['proprietes-beaute'], (_props$product7 = props.product) === null || _props$product7 === void 0 ? void 0 : (_props$product7$attri = _props$product7.attributes) === null || _props$product7$attri === void 0 ? void 0 : _props$product7$attri['proprietes-bien-etre']);
    });
    var bundleLabel = computed(function () {
      var _props$product8, _props$product8$attri;
      return (_props$product8 = props.product) === null || _props$product8 === void 0 ? void 0 : (_props$product8$attri = _props$product8.attributes) === null || _props$product8$attri === void 0 ? void 0 : _props$product8$attri['product-label'];
    });
    var isBestSeller = computed(function () {
      var _props$product9, _props$product9$attri;
      return (_props$product9 = props.product) === null || _props$product9 === void 0 ? void 0 : (_props$product9$attri = _props$product9.attributes) === null || _props$product9$attri === void 0 ? void 0 : _props$product9$attri['best-seller'];
    });
    var usageType = computed(function () {
      var _props$product0, _props$product0$attri;
      return (_props$product0 = props.product) === null || _props$product0 === void 0 ? void 0 : (_props$product0$attri = _props$product0.attributes) === null || _props$product0$attri === void 0 ? void 0 : _props$product0$attri['usage-type'];
    });
    var isBookShop = computed(function () {
      var _usageType$value;
      var value = (_usageType$value = usageType === null || usageType === void 0 ? void 0 : usageType.value) !== null && _usageType$value !== void 0 ? _usageType$value : '';
      return typeof value === 'string' && value.toLowerCase().startsWith('atelier');
    });
    var isBundle = computed(function () {
      var _props$product1, _props$product1$key;
      return (_props$product1 = props.product) === null || _props$product1 === void 0 ? void 0 : (_props$product1$key = _props$product1.key) === null || _props$product1$key === void 0 ? void 0 : _props$product1$key.startsWith('bundle');
    });
    var capacity = computed(function () {
      var _props$product10, _props$product10$vari, _variant$capacityUnit;
      var variant = (_props$product10 = props.product) === null || _props$product10 === void 0 ? void 0 : (_props$product10$vari = _props$product10.variants) === null || _props$product10$vari === void 0 ? void 0 : _props$product10$vari[0];
      var hasCapacity = typeof variant.capacity === 'number' && !isNaN(variant.capacity);
      var unit = (_variant$capacityUnit = variant.capacityUnit) !== null && _variant$capacityUnit !== void 0 ? _variant$capacityUnit : '';
      if (isBundle.value) {
        return unit;
      }
      if (isBookShop.value) {
        return '';
      }
      return hasCapacity ? "".concat(variant.capacity).concat(unit) : '';
    });

    /**
     * Return a variant object from a given SKU.
     *
     * @param {any[]} variants - Array of variant objects
     * @param {string} sku - The SKU to search for
     * @returns {any} - The matching variant object or an empty object
     */
    function getVariantBySku(variants, sku) {
      if (!Array.isArray(variants)) {
        console.warn('getVariantBySku: variants is not a valid array');
        return {};
      }
      if (typeof sku !== 'string') {
        console.warn('getVariantBySku: sku is not a valid string');
        return {};
      }
      var match = variants.find(function (variant) {
        return (variant === null || variant === void 0 ? void 0 : variant.sku) === sku;
      });
      if (!match) {
        console.warn("getVariantBySku: no variant found for sku \"".concat(sku, "\""));
        return {};
      }
      return match;
    }
    var masterVariant = computed(function () {
      return getVariantBySku(props.product.variants, props.product.masterVariantID);
    });
    var image = computed(function () {
      return masterVariant.value.images;
    });
    /**
     * Check if at least one variant has isInStock === true.
     *
     * @param {any[]} variants - Array of variant objects
     * @returns {boolean} - True if at least one variant is in stock, otherwise false
     */
    function hasVariantInStock(variants) {
      var _variants$some;
      if (!Array.isArray(variants)) {
        console.warn('hasVariantInStock: variants is not a valid array');
        return false;
      }
      return (_variants$some = variants.some(function (variant) {
        return (variant === null || variant === void 0 ? void 0 : variant.isInStock) === true;
      })) !== null && _variants$some !== void 0 ? _variants$some : false;
    }

    /**
     * Return regular and special price for a given country from EUR price set.
     *
     * @param {any} prices - Object containing prices by currency (e.g., { EUR: { ... } })
     * @param {string} countryCode - ISO 2-letter country code (e.g., "FR")
     * @returns {{ regular: number, special: number | null }} - Price information
     */
    function getPricesByCountry(prices, countryCode) {
      var _prices$EUR, _eurPrices$priceValue, _values$find, _match$value, _match$discountedValu;
      if (_typeof(prices) !== 'object') {
        console.warn('getPricesByCountry: prices is not a valid object');
        return {
          regular: 0,
          special: null
        };
      }
      var eurPrices = (_prices$EUR = prices.EUR) !== null && _prices$EUR !== void 0 ? _prices$EUR : null;
      if (_typeof(eurPrices) !== 'object') {
        console.warn('getPricesByCountry: EUR price data is missing or invalid');
        return {
          regular: 0,
          special: null
        };
      }
      var values = (_eurPrices$priceValue = eurPrices === null || eurPrices === void 0 ? void 0 : eurPrices.priceValues) !== null && _eurPrices$priceValue !== void 0 ? _eurPrices$priceValue : [];
      if (!Array.isArray(values)) {
        console.warn('getPricesByCountry: priceValues is not a valid array');
        return {
          regular: 0,
          special: null
        };
      }
      var match = (_values$find = values.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.country) === countryCode;
      })) !== null && _values$find !== void 0 ? _values$find : values.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.country) === 'Any';
      });
      if (!match) {
        console.warn("getPricesByCountry: no price found for country \"".concat(countryCode, "\""));
        return {
          regular: eurPrices.max,
          special: null
        };
      }
      return {
        regular: (_match$value = match.value) !== null && _match$value !== void 0 ? _match$value : 0,
        special: (_match$discountedValu = match.discountedValue) !== null && _match$discountedValu !== void 0 ? _match$discountedValu : null
      };
    }

    /**
     * Handles the action of navigating to the product page
     * and triggering the GTM event.
     */
    function goToProductPageAndGtmEvent() {
      gtmPushEvent('select_item', {
        event_category: 'ecommerce',
        event_action: 'click',
        event_label: title.value,
        event_name: 'select_item',
        page_url: route.fullPath,
        new_product: isNew.value,
        ecommerce: gtmEcommerceItems.value
      });
      router.push(link.value);
    }

    /**
     * Handles the different "add to cart" features
     */
    function handleAddToCart() {
      isBookShop.value ? bookNow() : addProductToCart();
    }
    var bookingFilterTagsValue = computed(function () {
      if (props.product) {
        var attribute = props.product.masterVariantID;
        return attribute || null;
      }
      return null;
    });

    /**
     * Opens the workshop booking modal (i.e. booxi)
     */
    function bookNow() {
      return _bookNow.apply(this, arguments);
    }
    /**
     * Adds the product to cart.
     */
    function _bookNow() {
      _bookNow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var serviceTags;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              serviceTags = bookingFilterTagsValue.value;
              _context2.next = 3;
              return loadBooxi();
            case 3:
              openBooxi({
                shopId: null,
                serviceTags: serviceTags,
                bookingFlow: 'locations',
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      nextRoutePath: '/checkout-workshop',
                      previousRoutePath: route.path,
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _bookNow.apply(this, arguments);
    }
    function addProductToCart() {
      return _addProductToCart.apply(this, arguments);
    }
    function _addProductToCart() {
      _addProductToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _price$value1, _price$value10, _cart$value, _props$product11, _ref, _price$value$special, priceAddToCart, _price$value11, _price$value12, _masterVariant$value, _masterVariant$value$, _price$value13, _price$value14, _props$product12, _props$product13, _masterVariant$value2, AddedProperties, productWithIndex;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!isVariant.value && !isInStock.value)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", openBackInStockModal(props.product));
            case 4:
              if (isVariant.value) {
                _context3.next = 23;
                break;
              }
              startWaiter("add-to-cart-".concat(productIdFromTags.value));
              _context3.prev = 6;
              priceAddToCart = {
                value: {
                  centAmount: Math.round((_ref = (_price$value$special = price.value.special) !== null && _price$value$special !== void 0 ? _price$value$special : price.value.regular) !== null && _ref !== void 0 ? _ref : 0)
                }
              };
              _context3.next = 10;
              return addItemById({
                product: {
                  sku: props.product.variants[0].sku,
                  price: priceAddToCart,
                  mainImage: image.value[0],
                  name: title.value
                },
                quantity: 1,
                showConfirmation: true,
                customQuery: {
                  updateCart: 'updateCartCustom'
                }
              });
            case 10:
              _context3.next = 15;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](6);
              console.error('Failed to add item to cart', _context3.t0);
            case 15:
              _context3.prev = 15;
              endWaiter("add-to-cart-".concat(productIdFromTags.value));
              return _context3.finish(15);
            case 18:
              trackDynamicYieldEvent({
                name: 'Add to Cart',
                properties: {
                  dyType: 'add-to-cart-v1',
                  value: formatDYprice(price.value.regular, price.value.special),
                  currency: 'EUR',
                  productId: masterVariant.value.sku,
                  quantity: 1,
                  cart: [{
                    productId: masterVariant.value.sku,
                    quantity: 1,
                    itemPrice: formatDYprice(price.value.regular, price.value.special)
                  }]
                }
              });
              $trackers.gtm.trackAddToCart({
                title: title.value,
                sku: masterVariant.value.sku,
                priceRegular: (_price$value1 = price.value) === null || _price$value1 === void 0 ? void 0 : _price$value1.regular,
                priceSpecial: (_price$value10 = price.value) === null || _price$value10 === void 0 ? void 0 : _price$value10.special,
                quantity: 1,
                isNewProduct: isNew.value,
                itemLocation: 'product_card',
                index: props.productIndex + 1,
                currency: currency,
                cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
                ctId: (_props$product11 = props.product) === null || _props$product11 === void 0 ? void 0 : _props$product11.objectID,
                pageUrl: route.fullPath
              });
              if (customerEmail) {
                AddedProperties = {
                  AddedToCartValue: gtmValue((_price$value11 = price.value) === null || _price$value11 === void 0 ? void 0 : _price$value11.regular, (_price$value12 = price.value) === null || _price$value12 === void 0 ? void 0 : _price$value12.special),
                  AddedItemCategories: 'product',
                  AddedItemCurrency: currency,
                  AddedItemImageURL: (_masterVariant$value = masterVariant.value) === null || _masterVariant$value === void 0 ? void 0 : (_masterVariant$value$ = _masterVariant$value.images[0]) === null || _masterVariant$value$ === void 0 ? void 0 : _masterVariant$value$.url,
                  AddedItemPrice: (_price$value13 = price.value) === null || _price$value13 === void 0 ? void 0 : _price$value13.regular,
                  AddedItemPriceDiscount: ((_price$value14 = price.value) === null || _price$value14 === void 0 ? void 0 : _price$value14.special) || '',
                  AddedItemProductID: (_props$product12 = props.product) === null || _props$product12 === void 0 ? void 0 : _props$product12.objectID,
                  AddedItemProductName: (_props$product13 = props.product) === null || _props$product13 === void 0 ? void 0 : _props$product13.name,
                  AddedItemProductSKU: (_masterVariant$value2 = masterVariant.value) === null || _masterVariant$value2 === void 0 ? void 0 : _masterVariant$value2.sku,
                  AddedItemProductUrl: link.value,
                  AddedItemQuantity: 1,
                  AddedItemURL: route.fullPath
                };
                klaviyoClientPushEvent(customerEmail, locale, AddedProperties, 'Added to cart');
              }
              _context3.next = 25;
              break;
            case 23:
              productWithIndex = _objectSpread(_objectSpread({}, props.product), {}, {
                _slug: props.product.slug,
                images: [{
                  url: image.value[0]
                }],
                productIndex: 1
              });
              openAddToCartModal(productWithIndex);
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 12, 15, 18]]);
      }));
      return _addProductToCart.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      currency: currency,
      locale: locale,
      user: user,
      isAuthenticated: isAuthenticated,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      formatDYprice: formatDYprice,
      addItemById: addItemById,
      cart: cart,
      app: app,
      $trackers: $trackers,
      currentCountry: currentCountry,
      getProductPath: getProductPath,
      getFinalAttributeFromStrings: getFinalAttributeFromStrings,
      router: router,
      route: route,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      doActionOrLogin: doActionOrLogin,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      openBackInStockModal: openBackInStockModal,
      openAddToCartModal: openAddToCartModal,
      customerEmail: customerEmail,
      productIdFromTags: productIdFromTags,
      reviewsSku: reviewsSku,
      isInStock: isInStock,
      variantCount: variantCount,
      isVariant: isVariant,
      price: price,
      isNew: isNew,
      link: link,
      title: title,
      gtmEcommerceItems: gtmEcommerceItems,
      finalAttributesString: finalAttributesString,
      bundleLabel: bundleLabel,
      isBestSeller: isBestSeller,
      usageType: usageType,
      isBookShop: isBookShop,
      isBundle: isBundle,
      capacity: capacity,
      getVariantBySku: getVariantBySku,
      masterVariant: masterVariant,
      image: image,
      hasVariantInStock: hasVariantInStock,
      getPricesByCountry: getPricesByCountry,
      goToProductPageAndGtmEvent: goToProductPageAndGtmEvent,
      handleAddToCart: handleAddToCart,
      bookingFilterTagsValue: bookingFilterTagsValue,
      bookNow: bookNow,
      addProductToCart: addProductToCart,
      AverageRatingCount: AverageRatingCount,
      AzLoader: AzLoader,
      AzIcon: AzIcon,
      AzButton: AzButton,
      AzImg: AzImg,
      PriceDiscountLabel: PriceDiscountLabel,
      WishlistButton: WishlistButton,
      PriceDisplay: PriceDisplay
    };
  }
});